<template>
<div class="chapter">
<div class="inner_page">
<div id="ded">
<p class="noindent">This book is dedicated to my home team: Judy, Clayton and Christine, Karl and Christina, Cara, Elaine and Tessa, Brendan and Christian Kilduff, and Pearl – also to my friend and mentor, the late Clayton Knight, OBE, who was also a friend of Billy Bishop’s.</p>
<p class="fh1"><b>Other books by Peter Kilduff</b></p>
<p class="noindent"><i>The Red Baron</i></p>
<p class="noindent"><i>That’s My Bloody Plane</i></p>
<p class="noindent"><i>Germany’s Last Knight of the Air</i></p>
<p class="noindent"><i>U.S. Carriers at War</i></p>
<p class="noindent"><i>A-4 Skyhawk</i></p>
<p class="noindent"><i>Germany’s First Air Force 1914-1918</i></p>
<p class="noindent"><i>Richthofen – Beyond the Legend of the Red Baron</i></p>
<p class="noindent"><i>Over the Battlefronts</i></p>
<p class="noindent"><i>The Red Baron Combat Wing</i></p>
<p class="noindent"><i>The Illustrated Red Baron</i></p>
<p class="noindent"><i>Talking With the Red Baron</i></p>
<p class="noindent"><i>Red Baron – The Life and Death of an Ace</i></p>
<p class="noindent"><i>Black Fokker Leader</i></p>
<p class="noindent"><i>Hermann Göring – Fighter Ace</i></p>
<p class="noindent"><i>Iron Man Rudolf Berthold: Germany’s Indomitable World War I Fighter Ace</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_ded.vue?322d8734